import { Reducer } from 'react';

import { Actions } from './constants';
import { ActionsType, State } from './types';

const initialState: State = {
  list: {},
  isLoading: false,
  error: undefined,
};

const historiesReducer: Reducer<State, ActionsType> = (state = initialState, action) => {
  switch (action.type) {
    case Actions.GET_HISTORIES_PENDING:
      return {
        ...state,
        isLoading: true,
      };
    case Actions.GET_HISTORIES_SUCCESS:
      return {
        ...state,
        isLoading: false,
        list: action.payload,
        error: undefined,
      };
    case Actions.GET_HISTORIES_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.payload.message,
        list: {},
      };

    default:
      return state;
  }
};

export default historiesReducer;
